<template>
  <div class="element-input element-spread-select">
    <div class="label" @click="clickHelp">
      <p>
        <span :class="{ active: dropbox && statusHelp }">{{ label }}</span>
        <img v-if="dropbox" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'" />
      </p>
      <div class="dropbox" v-if="dropbox && statusHelp">
        {{ dropbox }}
      </div>
    </div>
    <ul :class="[ items.length != 3 ?  'sp-wd' : 'eq-wd' ]">
      <li :class="{ on: value == item.value }" 
        v-if="((tag && item.tag == tag) || !tag) && filter(item)" 
        v-for="item in items" @click="selectItem( item )">
        <div>{{ item.label }}</div>
      </li>
    </ul>
    <div class="error" v-if="error">{{ error }}</div>
    <slot />
    <div class="form-item-caution" v-if="cautiontextView">{{cautiontext}}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items", "tag", "dropbox", "usage", "carType", "cautiontextView" ],
  data(){
    return {
      statusHelp: false,
      cautiontext: "운전자 범위를 선택하세요."
    }
  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {
    filter( item ){
      if(this.usage === '법인'){
        if(this.carType === '승용차'){
          return this.usage == item.userCategory
        }
        else{
          return this.usage == item.userCategory && !item.carCategory
        }
      }
      else{
        return this.usage == item.userCategory
      }
    },
    clickHelp(){
      this.statusHelp = !this.statusHelp
    },
    selectItem( item ){
      if(item.description) this.cautiontext = item.description
      this.$emit( "input", item.value );
    }
  }
}
</script>
